import { useEffect, useState } from "react";
import { useAuth } from "./AuthContext";

export default function SystemStatusBanner() {
  const { user } = useAuth();
  const [warnings, setWarnings] = useState([]);

  useEffect(() => {
    if (user?.role !== "admin") return;
    const load = () => fetch("/api/admin/system-status", { credentials: "include" })
      .then(r => (r.ok ? r.json() : null))
      .then(d => d && setWarnings(d.warnings || []))
      .catch(() => {});
    load();
    const timer = setInterval(load, 30 * 60 * 1000);
    return () => clearInterval(timer);
  }, [user?.role]);

  if (!warnings.length) return null;
  return (
    <div style={{ background: "#991b1b", color: "#fff", fontSize: 12.5, fontWeight: 600, padding: "8px 14px" }}>
      {warnings.map(w => <div key={w}>⚠ {w}</div>)}
    </div>
  );
}
